<template>
  <div class="connect-exchanges-content-connect">
    <form class="connect-exchanges-content-connect__form">
      <BaseInput v-model="connection.api_key" placeholder="Enter your API Key" />
      <BaseInput v-model="connection.secret" placeholder="Enter your Secret Key" />
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BaseInput from '@/components/ui/atoms/BaseInput.vue';

export default {
  name: "ConnectExchangesContentConnect",
  components: { BaseInput },
  data() {
    return {
      connection: {
        aou_key: null,
        secret: null,
      }
    }
  },
  watch: {
    connection: {
      deep: true,
      handler(value) {
        this.$emit('connection-change', value)
      }
    }
  },
  methods: {
    ...mapActions({
      setIsLoading: 'setIsLoading'
    })
  }
};
</script>
<style lang="scss" scoped>
.connect-exchanges-content-connect {

  &__form {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    ::v-deep .base-input__block__value {
      font-size: 1rem;
      width: 100%;
      background: white;
    }

    ::v-deep .base-input__block__label {
      background: white;
    }
  }

}
</style>